// src/components/sections/AboutSection.js
import { useQuery } from 'react-query';
import { useLang } from '../../i18n/LanguageContext';
import { useSiteConfig } from '../../context/SiteConfigContext';
import { fetchFeatures } from '../../services/api';
import { LoadingSpinner } from '../ui';
import styles from './AboutSection.module.css';

export default function AboutSection() {
  const { t, ui } = useLang();
  const { config } = useSiteConfig();

  const { data: features = [], isLoading } = useQuery('features', fetchFeatures, {
    staleTime: 1000 * 60 * 10,
  });

  return (
    <section className={styles.section} id="about">
      <div className={styles.container}>

        {/* Text side */}
        <div className={styles.text}>
          <div className="tag-badge">{ui('✦ درباره کیوت کندل', '✦ About Cute Candels')}</div>
          <h2 className={`${styles.title} grad-text`}>
            {t(config, 'about_title')}
          </h2>
          <p className={styles.body}>{t(config, 'about_body')}</p>
          <p className={styles.body2}>{t(config, 'about_body2')}</p>
        </div>

        {/* Features grid */}
        <div className={styles.grid}>
          {isLoading
            ? Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="skeleton" style={{ height: 120, borderRadius: 'var(--radius-lg)' }} />
              ))
            : features.map((feat) => (
                <div key={feat.id} className={`${styles.card} card`}>
                  <span className={styles.icon}>{feat.icon}</span>
                  <h3 className={styles.cardTitle}>{t(feat, 'title')}</h3>
                  <p className={styles.cardDesc}>{t(feat, 'description')}</p>
                </div>
              ))
          }
        </div>

      </div>
    </section>
  );
}
